<template lang="pug">
.draft-envelopes-card-table
  card-table(:total-items='data.length' breakpoint-size='lg')
    template(v-for='(item, index) in data' v-slot:[`card-${index}`]='{}')
      .mb-1.text-overflow-ellipse(style='width: 90%') {{ getEnvelopeName(item) }}
      .mb-1 {{ $t('draftEnvelopesCardTable.id') }}: {{ item.hashid }}
      .mb-0 {{ $t('draftEnvelopesCardTable.creationDate') }}: {{ item.created_at | dateTime }}
      template(v-if='$root.isMobile')
        button(
          :disabled='!canEdit'
          :title='$t("draftEnvelopesCardTable.use")'
          data-bs-target='#new-envelope-mobile-modal'
          data-bs-toggle='modal'
          style='position: absolute; top: 0.75rem; right: 0.45rem'
          type='button'
        )
          icon(name='pen-to-square')
      template(v-else)
        button(
          :title='$t("draftEnvelopesCardTable.use")'
          @click.stop='openDraft(item)'
          style='color: inherit; position: absolute; top: 0.75rem; right: 0.8rem'
          type='button'
        )
          icon(name='pen-to-square')
      button(
        :disabled='!canDelete'
        :title='$t("draftEnvelopesCardTable.delete")'
        @click.stop='selectedEnvelopeId = item.id'
        data-bs-target='#delete-envelope-modal'
        data-bs-toggle='modal'
        style='position: absolute; bottom: 1rem; right: 0.5rem'
      )
        icon.icon--canceled(name='trash-can')
    template(v-slot:table-head)
      th(style='width: 5%') {{ $t('draftEnvelopesCardTable.id') }}
      th(style='width: 60%') {{ $t('draftEnvelopesCardTable.name') }}
      th(style='width: 30%')
        .d-flex
          span.text {{ $t('draftEnvelopesCardTable.creationDate') }}
          button(
            @click='addSort("created_at", "DESC")'
            style='margin-top: -2px'
            v-show='sort.created_at === "ASC"'
          )
            icon.icon--blue(name='angle-down')
          button(
            @click='addSort("created_at", "ASC")'
            style='margin-top: -2px'
            v-show='sort.created_at !== "ASC"'
          )
            icon.icon--blue(name='angle-up')
      th(style='width: 5%')
        span.text {{ $t('draftEnvelopesCardTable.actions') }}
    template(v-for='(item, index) in data' v-slot:[`table-row-${index}`]='{}')
      td {{ item.hashid }}
      td
        .draft-envelopes-card-table__name.text-overflow-ellipse(
          :title='getEnvelopeName(item)'
        ) {{ getEnvelopeName(item) }}
      td {{ item.created_at | dateTime }}
      td
        .d-flex
          template(v-if='$root.isMobile')
            button(
              :disabled='!canEdit'
              :title='$t("draftEnvelopesCardTable.use")'
              @click.stop=''
              data-bs-target='#new-envelope-mobile-modal'
              data-bs-toggle='modal'
              type='button'
            )
              icon.icon--blue(name='pen-to-square')
          template(v-else)
            button(
              :title='$t("draftEnvelopesCardTable.use")'
              @click.stop='openDraft(item)'
              style='color: inherit'
              type='button'
            )
              icon.icon--blue(name='pen-to-square')
          button.ms-2(
            :disabled='!canDelete'
            :title='$t("draftEnvelopesCardTable.delete")'
            @click.stop='selectedEnvelopeId = item.id'
            data-bs-target='#delete-envelope-modal'
            data-bs-toggle='modal'
          )
            icon.icon--canceled(name='trash-can')
  delete-envelope-modal(
    :envelope-id='selectedEnvelopeId'
    @refresh='$emit("item-deleted", selectedEnvelopeId)'
  )
  new-envelope-mobile-modal
</template>
<script>
import EnvelopeState from '@/enums/EnvelopeState';
import RecipientState from '@/enums/RecipientState';
import Icon from '@/ui/atoms/Icon.vue';
import IconStatus from '@/ui/atoms/IconStatus.vue';
import CardTable from '@/ui/organisms/CardTable.vue';
import EnvelopeSignaturesProgress from '@/ui/molecules/EnvelopeSignaturesProgress.vue';
import DeleteEnvelopeModal from '@/modules/business/components/organisms/modals/DeleteEnvelopeModal.vue';
import NewEnvelopeMobileModal from '@/modules/business/components/organisms/modals/NewEnvelopeMobileModal.vue';
import PermissionsService from '@/services/PermissionsService';
import ApiPermissions from '@/enums/ApiPermissions';
import alert from '@/modules/account/common/alert';

export default {
  name: 'ReceivedEnvelopesCardTable',
  components: {
    Icon,
    IconStatus,
    CardTable,
    EnvelopeSignaturesProgress,
    DeleteEnvelopeModal,
    NewEnvelopeMobileModal,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      EnvelopeState,
      RecipientState,
      sort: {
        created_at: '',
      },
      selectedEnvelopeId: '',
    };
  },
  computed: {
    canEdit() {
      return PermissionsService.can(
        this.$root.user,
        ApiPermissions.ENVELOPE_UPDATE
      );
    },
    canDelete() {
      return PermissionsService.can(
        this.$root.user,
        ApiPermissions.ENVELOPE_DELETE
      );
    },
  },
  methods: {
    addSort(column, type) {
      this.sort[column] = type;
      this.$emit('sort', {
        column: column,
        desc: type === 'DESC',
      });
    },

    checkNextOrderByColumnIsDesc(column) {
      if (column === this.sort.column) {
        return !this.sort.desc;
      }
      return false;
    },
    openDraft(item) {
      if (!this.canEdit) {
        const action = this.$t('draftEnvelopesCardTable.use');
        alert.fireAlert(this.$t('insufficientPermission', { action }), {
          classes: 'alert-warning',
          tag: 'httpAlert',
          icon: 'triangle-exclamation',
        });
        return;
      }
      this.$router.push(this.getRoute(item)).catch(() => {});
    },
    getRoute(item) {
      const route = {
        name: 'business.envelope.documents',
        params: {
          id: item.id,
        },
      };
      if (
        item.state === EnvelopeState.IN_TRANSIT &&
        item.state !== RecipientState.DONE
      ) {
        route.name = 'business.envelopes.viewer';
      }
      return route;
    },
    getEnvelopeName(item) {
      return item.title && item.title !== 'old' ? item.title : item.subject;
    },
  },
};
</script>
<style lang="stylus">
.draft-envelopes-card-table__name
  max-width: 180px;
@media (min-width: 576px)
  .draft-envelopes-card-table__name
    max-width: 180px
@media (min-width: 768px)
  .draft-envelopes-card-table__name
    max-width: 180px
@media (min-width: 992px)
  .draft-envelopes-card-table__name
    max-width: 500px
@media (min-width: 1200px)
  .draft-envelopes-card-table__name
    max-width: 470px
@media (min-width: 1400px)
  .draft-envelopes-card-table__name
    max-width: 640px
</style>
